import React, { FunctionComponent, JSX, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide } from "@material-ui/core";
import "./poup.css"
import Button from "../Button/Button";

interface Props {
    className?: string,
    title: string | JSX.Element,
    button?: ButtonProps,
    handle_close: () => void,
    open?: boolean,
    short?: boolean,
    children: React.ReactNode
}

export type ButtonProps = (IButtonJsx | IButtonText) & IButtonProps;

interface IButtonProps {
    render(): JSX.Element
};

interface IButtonJsx {
    ok: JSX.Element,
    cancel: JSX.Element
}

interface IButtonText extends IButtonProps {
    ok?: IButtonTextProps,
    cancel?: IButtonTextProps
}

type IButtonTextProps = {
    text: string,
    on_click: () => void
} | {
    text: string,
    on_click: (stop_loading: () => void) => void,
    enable_loading: true
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * @deprecated
 */
const Popup: FunctionComponent<Props> = (props) => {

    const open = props.open ? props.open : false;
    const class_name = props.className ? props.className : "";

    return (
        <Dialog
            id="dialog" fullWidth
            maxWidth="xs" open={open} className={"bottom_dialog" + " " + class_name}
            aria-label={props.short ? "short" : ""}
            onClose={props.handle_close}
            scroll={"paper"}
            TransitionComponent={Transition as any}
        >
            <DialogTitle className={"fixed_top_text"}>{props.title}</DialogTitle>
            <DialogContent className={"border_fixed"}>
                {props.children}
            </DialogContent>
            {
                props.button && (
                    <DialogActions className={"fixed_bottom_text"}>
                        <div className={"button_container_popup"}>
                            {props.button?.render()}
                        </div>
                    </DialogActions>
                )
            }
        </Dialog>
    );
}

export class ButtonTextJsx implements IButtonText {
    cancel?: IButtonTextProps;
    ok?: IButtonTextProps;

    constructor(cancel?: IButtonTextProps, ok?: IButtonTextProps) {
        this.cancel = cancel;
        this.ok = ok;
    }

    render() {
        return <ButtonsTextFunctional cancel={this.cancel} ok={this.ok} />
    }
}

const ButtonsTextFunctional: FunctionComponent<{
    cancel?: IButtonTextProps,
    ok?: IButtonTextProps
}> = (props) => {

    const [isDisabled, setIsDisabled] = useState(false);

    return (
        <>
            {
                props.cancel && (
                    <SingleButtonTextFunctional
                        {...props.cancel}
                        secondary
                        is_disabled={isDisabled}
                        set_disabled={setIsDisabled}
                    />
                )
            }
            {
                props.ok && (
                    <SingleButtonTextFunctional
                        secondary={false}
                        {...props.ok}
                        is_disabled={isDisabled}
                        set_disabled={setIsDisabled}
                    />
                )
            }
        </>
    )
}

type ISingleButtonProps = (IButtonTextProps & {
    secondary?: boolean,
    is_disabled: boolean,
    set_disabled: (is_disabled: boolean) => void
}) | undefined

const SingleButtonTextFunctional: FunctionComponent<ISingleButtonProps> = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    if (props === undefined) return null;

    let on_click_with_loading = () => {
        if (isLoading && !props.is_disabled)
            return;
        props.set_disabled(true)
        setIsLoading(true);
        props.on_click(() => {
            setIsLoading(false)
            props.set_disabled(false)
        });
    }

    let on_click = on_click_with_loading;
    if (!("enable_loading" in props))
        on_click = props.on_click;

    return <>
        {
            props && (
                <Button secondary={props.secondary} onClick={on_click} loading={isLoading} disabled={props.is_disabled}>
                    {props.text}
                </Button>
            )
        }
    </>

}

export class ButtonElementJsx implements IButtonJsx {
    cancel: JSX.Element;
    ok: JSX.Element;

    constructor(ok: JSX.Element, cancel: JSX.Element) {
        this.cancel = cancel;
        this.ok = ok;
    }

    render() {
        return (
            <>
                {this.ok}
                {this.cancel}
            </>
        );
    }
}

export default Popup;